let transferIndex = 0;

function transferIncrease() {
    transferIndex++;
}

export {transferIndex, transferIncrease};


// WEBPACK FOOTER //
// ./src/utils/transfer-queue.js